import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core';
import {
  PresignedUploadRequestDto,
  PresignedUploadResponseDto,
  ConfirmUploadRequestDto,
  ConfirmUploadResponseDto
} from '@shared';

@Injectable({ providedIn: 'root' })
export class InvestigationFilesApi {
  private readonly _http = inject(HttpClient);
  private readonly _config = inject(AppConfigService);

  public getPresignedUploadUrl(investigationId: string, request: PresignedUploadRequestDto): Observable<PresignedUploadResponseDto> {
    return this._http.post<PresignedUploadResponseDto>(`${this._config.versionedApiUrl}/investigations/${investigationId}/attachment-upload-url`, request);
  }

  public confirmUpload(investigationId: string, request: ConfirmUploadRequestDto): Observable<ConfirmUploadResponseDto> {
    return this._http.post<ConfirmUploadResponseDto>(`${this._config.versionedApiUrl}/investigations/${investigationId}/attachments`, request);
  }
}
